import { baseApiUrl } from '../envConfig';
import store from '../reduxStore';
import APIV1 from './axios/APIV1';
var token = store.getState().auth.token;
var restaurantID = store.getState().auth.restaurantId;

export const getRestaurantById = async () => {
    const restaurant = await fetch(`${baseApiUrl}/restaurants/${restaurantID}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
        },
    });
    const restaurantJson = await restaurant.json();
    return restaurantJson;
};

export const editRestaurantById = async ({ data }) => {
    const restaurant = await fetch(`${baseApiUrl}/restaurants/${restaurantID}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
        },
        body: JSON.stringify(data),
    });
    const restaurantJson = await restaurant.json();
    return restaurantJson;
};

export const addOutletIntoRestaurant = async (data) => {
    try {
        const response = await APIV1.post('/subscription-requests', data);
        return response.data;
    } catch (error) {
        console.error('Error creating outlet:', error);
        throw new Error(error.response?.data?.message || 'Failed to create outlet');
    }
};

export const editOutletIntoRestaurant = async (subscriptionId, data) => {
    try {
        const response = await APIV1.put(`/subscription-requests/${subscriptionId}`, data);
        return response.data;
    } catch (error) {
        console.error('Error editing outlet:', error);
        throw new Error(error.response?.data?.message || 'Failed to edit outlet');
    }
};
